import api from '@/utils/api';

/**
 * Reinstate a user by ID
 * @param {string} id - The user ID
 * @returns {Promise} - A promise that resolves when the user is reinstated
 */
const reinstateUser = (id) => api.post(`/user/${id}/reinstate`);

export default reinstateUser;
